module.exports = __webpack_public_path__ + "img/2023big6.e358d5a0.png";